import firebase from "firebase";
import Nft from "../../models/nft";
export const SET_NFTS = "SET_NFTS";
export const ADD_NFTS = "ADD_NFTS";
export const UPDATE_NFT_ANIMATION = "UPDATE_NFT_ANIMATION";
export const ADD_PUBLICKEY = "ADD_PUBLICKEY";
export const SET_PUBLICKEY = "SET_PUBLICKEY";

const writeNftData = (plat, userId, nfts, method) => {
  const nftsObj = {};
  for (const nft of nfts) {
    nftsObj[nft.id] = nft;
  }
  let ref = firebase
    .database()
    .ref()
    .child("users")
    .child(userId)
    .child("contents")
    .child(plat);

  console.log("writeNftData");
  if (method === "SET") {
    return ref.set(nftsObj);
  } else if (method === "UPDATE") {
    return ref.update(nftsObj);
  }
};

export const fetchPublicKeys = () => {
  return async (dispatch) => {
    try {
      let resData;
      const userId = firebase.auth().currentUser.uid;
      console.log("fetchPublicKeys");
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("users")
        .child(userId)
        .child("publicKeys")
        .child("ETHEREUM")
        .get()
        .then((snapshot) => {
          if (snapshot.exists()) {
            resData = snapshot.val();
            console.log("snapshot key data" + resData);
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          console.error(error);
          throw new Error("Something went wrong!");
        });

      //const resData = await response.json();
      const loadedKeys = [];

      for (const key in resData) {
        loadedKeys.push(resData[key]);
      }
      console.log("loadedKeys", loadedKeys, typeof loadedKeys);

      dispatch({
        type: SET_PUBLICKEY,
        publicKeys: loadedKeys,
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};

export const removePublicKeys = () => {
  return async (dispatch) => {
    try {
      const userId = firebase.auth().currentUser.uid;
      console.log("removePublicKeys");
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("users")
        .child(userId)
        .child("publicKeys")
        .child("ETHEREUM")
        .remove();

      dispatch({
        type: SET_PUBLICKEY,
        publicKeys: [],
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};

export const fetchNfts = (plat) => {
  return async (dispatch, getState) => {
    const userId = firebase.auth().currentUser.uid;
    console.log("fetchNfts");

    try {
      let resData;
      let hasChineseFloralSkull = false;
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("users")
        .child(userId)
        .child("contents")
        .child(plat)
        .get()
        .then((snapshot) => {
          if (snapshot.exists()) {
            resData = snapshot.val();
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          console.error(error);
          throw new Error("Something went wrong!");
        });

      //const resData = await response.json();
      const loadedNfts = [];

      for (const key in resData) {
        let animationUrl = resData[key].animationUrl;
        if (key == "0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d_1") {
          hasChineseFloralSkull = true;
          animationUrl =
            "https://bafybeigs63be2c6g7ryedtmygiyzx2xhjgoqvwtktnyqo7hqvacim7syb4.ipfs.infura-ipfs.io/winter/winter-00-04-05.mp4";
        }
        loadedNfts.push(
          new Nft(
            key,
            resData[key].title,
            resData[key].imageUrl,
            resData[key].artist,
            resData[key].collection,
            resData[key].blockchain,
            resData[key].contractAddr,
            resData[key].tokenId,
            resData[key].collectionImageUrl,
            resData[key].imageOriginalUrl,
            resData[key].imageThumbnailUrl,
            animationUrl
          )
        );
      }
      dispatch({
        type: SET_NFTS,
        newNfts: loadedNfts,
      });
      if (hasChineseFloralSkull) {
        console.log("hasChineseFloralSkull");
        dispatch(updateChineseFloralSkull());
      }
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};
export const addPublicKey = (chain, publicKey) => {
  const userId = firebase.auth().currentUser.uid;

  return async (dispatch, getState) => {
    console.log("addPublicKey");
    // let myKey = new Object();
    // myKey[chain] = publicKey;
    // console.log(myKey);

    let postListRef = firebase
      .database()
      .ref("users/" + userId + "/publicKeys")
      .child(chain);

    let newPostRef = postListRef;
    newPostRef.push(publicKey);

    dispatch({
      type: ADD_PUBLICKEY,
      newPublicKey: publicKey,
    });
    if (chain === "ETHEREUM") {
      dispatch(fetchOpensea(publicKey, 0, "SET"));
    }
  };
};

export const fetchSolana = (solPublicKey, offset, method) => {
  return async (dispatch, getState) => {
    try {
      console.log("fetchSolana,offset=", offset);
      const userId = firebase.auth().currentUser.uid;
      console.log("userid=" + userId);
      const transformedNfts = [];
      //https://docs.theblockchainapi.com/#operation/solanaGetNFT
      //https://api-mainnet.magiceden.io/rpc/getNFTByMintAddress/DugthRKbQZRMcDQQfjnj2HeSjz2VARPC8H9abxdNK2SS
      let apiUrl = `https://api.opensea.io/api/v1/assets?owner=${ethPublicKey}&order_direction=desc&offset=${offset}&limit=50`;
      const options = {
        method: "GET",
        headers: { "X-API-KEY": "f840c2f2344c48828a97408475d6b54a" },
      };
      const response = await fetch(apiUrl, options);
      const json = await response.json();
      for (const key in json.assets) {
        //using keyName will cause checkbox in Profile screen to fail.
        const keyName =
          json.assets[key].asset_contract.address +
          "_" +
          json.assets[key].token_id;
        console.log("keyName = ", json.assets[key].name);
        transformedNfts.push(
          new Nft(
            keyName,
            json.assets[key].name,
            json.assets[key].image_url,
            json.assets[key].collection.name, //FIXME: Think about this artist field
            json.assets[key].collection.name,
            "Ethereum",
            json.assets[key].asset_contract.address,
            json.assets[key].token_id,
            json.assets[key].asset_contract.image_url,
            json.assets[key].image_thumbnail_url,
            json.assets[key].image_original_url,
            json.assets[key].animation_original_url,
            json.assets[key].image_url
          )
        );
      }
      //const writeResponse = await addNfts(transformedNfts);
      console.log("method=", method);
      const writeResponse = await writeNftData(
        "ETHEREUM",
        userId,
        transformedNfts,
        method
      );
      console.log("fetchSolana");

      dispatch({
        type: method === "SET" ? SET_NFTS : ADD_NFTS,
        newNfts: transformedNfts,
      });

      console.log("fetchSolana");
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};
export const fetchOpensea = (ethPublicKey, offset, method) => {
  return async (dispatch, getState) => {
    try {
      console.log(
        "fetchOpensea2,offset=",
        offset,
        "ethPublicKey=" + ethPublicKey
      );
      const userId = firebase.auth().currentUser.uid;
      let hasChineseFloralSkull = false;
      console.log("userid=" + userId);
      const transformedNfts = [];
      //let apiUrl = `https://api.opensea.io/api/v1/assets?owner=${ethPublicKey}&order_direction=desc&offset=${offset}&limit=50`;
      // let apiUrl = `https://silo-socket-server-staging.herokuapp.com/https://api.opensea.io/api/v1/assets?owner=${ethPublicKey}&order_direction=desc&offset=${offset}&limit=50`;
      let apiUrl = `https://silo-socket-server.herokuapp.com/https://api.opensea.io/api/v1/assets?owner=${ethPublicKey}&order_direction=desc&offset=${offset}&limit=50`;
      const options = {
        method: "GET",
        headers: {
          "X-API-KEY": "f840c2f2344c48828a97408475d6b54a",
        },
      };
      const response = await fetch(apiUrl, options);
      const json = await response.json();
      for (const key in json.assets) {
        //using keyName will cause checkbox in Profile screen to fail.
        const keyName =
          json.assets[key].asset_contract.address +
          "_" +
          json.assets[key].token_id;
        console.log(
          "keyName = ",
          keyName
          // json.assets[key].creator
        );
        let animation_original_url = json.assets[key].animation_original_url;
        if (keyName == "0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d_1") {
          hasChineseFloralSkull = true;
          animation_original_url =
            "https://bafybeigs63be2c6g7ryedtmygiyzx2xhjgoqvwtktnyqo7hqvacim7syb4.ipfs.infura-ipfs.io/winter/winter-00-04-05.mp4";
        }
        transformedNfts.push(
          new Nft(
            keyName,
            json.assets[key].name,
            json.assets[key].image_url,
            json.assets[key].collection.name, //FIXME: tried creator?.user?.username, but has null
            json.assets[key].collection.name,
            "Ethereum",
            json.assets[key].asset_contract.address,
            json.assets[key].token_id,
            json.assets[key].asset_contract.image_url,
            json.assets[key].image_thumbnail_url,
            json.assets[key].image_original_url,
            animation_original_url
          )
        );
      }

      //const writeResponse = await addNfts(transformedNfts);
      console.log("method=", method);
      const writeResponse = await writeNftData(
        "ETHEREUM",
        userId,
        transformedNfts,
        method
      );
      console.log("fetchOpensea3");
      console.log(transformedNfts);

      dispatch({
        type: method === "SET" ? SET_NFTS : ADD_NFTS,
        newNfts: transformedNfts,
      });

      console.log("fetchOpensea4");
      // await loadChineseFloralSkull();
      if (hasChineseFloralSkull) {
        console.log("hasChineseFloralSkull");
        dispatch(updateChineseFloralSkull());
      }
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};
const updateChineseFloralSkull = () => {
  // Add special handling to support special metadata for this NFT: https://opensea.io/assets/0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d/1
  return async (dispatch, getState) => {
    console.log("updateChineseFloralSkull1");
    const userId = firebase.auth().currentUser.uid;

    let resData =
      "https://bafybeigs63be2c6g7ryedtmygiyzx2xhjgoqvwtktnyqo7hqvacim7syb4.ipfs.infura-ipfs.io/winter/winter-00-04-05.mp4";
    const dbRef = firebase.database().ref();
    const response = await dbRef
      .child("customization")
      .child("0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d_1")
      .child("animationUrl")
      .get()
      .then((snapshot) => {
        if (snapshot.exists()) {
          resData = snapshot.val();
          console.log("updateChineseFloralSkull:", resData);
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
        // throw new Error("Something went wrong!");
      });
    console.log("updateChineseFloralSkull2");
    let write = dbRef
      .child("users")
      .child(userId)
      .child("contents")
      .child("ETHEREUM")
      .child("0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d_1")
      .child("animationUrl")
      .set(resData);

    dispatch({
      type: UPDATE_NFT_ANIMATION,
      id: "0x54e86412272c7f45ebf5ed5b6c17e12eb000a80d_1",
      updatedAnimationUrl: resData,
    });
    console.log("updateChineseFloralSkull3");
  };
};
export const resetNftDatabase = () => {
  return async (dispatch, getState) => {
    const userId = firebase.auth().currentUser.uid;
    console.log("resetNftDatabase");

    try {
      let resData;
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("users")
        .child(userId)
        .child("contents")
        .remove()
        .catch((error) => {
          console.error(error);
          throw new Error("Something went wrong!");
        });

      //const resData = await response.json();
      const loadedNfts = [];

      dispatch({
        type: SET_NFTS,
        newNfts: loadedNfts,
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};

export const logoutCleanup = () => {
  return async (dispatch, getState) => {
    console.log("logoutCleanup");

    try {
      dispatch({
        type: SET_NFTS,
        newNfts: [],
      });
      dispatch({
        type: SET_PUBLICKEY,
        publicKeys: [],
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};

// export const addNfts = (nfts) => {
//   console.log("addNfts");
//   const userId = firebase.auth().currentUser.uid;
//   return async (dispatch) => {
//     try {
//       console.log("addNfts2");
//       const response = await writeNftData(userId, nfts);
//       if (!response.ok) {
//         throw new Error("Something went wrong!");
//       }
//       dispatch({ type: ADD_NFTS, newNfts: nfts });
//     } catch (err) {
//       throw err;
//     }
//   };
// };
